import React, { useEffect, useState } from "react";
import ApiClient from "../../../methods/api/apiClient";
import environment from "../../../environment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import loader from "../../../methods/loader";
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const CSVEditor = React.memo(({ file, getData = () => { }, CSVEditorModal }) => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [FullData, setFullData] = useState({});
    const [fileName, setFileName] = useState("edited_data.csv");

    useEffect(() => {
        if (file) {
            let url;
            if (id === environment?.rfpsId) {
                url = `import/loads/preview?board_id=${environment?.rfpsId}`;
            } else if (id === environment?.contractId) {
                url = `import/contract/loads/preview?board_id=${environment?.contractId}`;
            } else {
                url = `import/loads/preview?board_id=${id}`;
            }
            loader(true);
            ApiClient.postFormData(url, { file }).then((res) => {
                try {
                    document.getElementById('importFiler').value = '';
                } catch { }

                if (res.success && res.data?.mappedResults?.length) {
                    setFullData(res?.data);
                    const newHeaders = res.data.labels || Object.keys(res.data.mappedResults[0]);
                    setHeaders(newHeaders);
                }
                loader(false);
            });
        }
    }, [file, CSVEditorModal]);

    const TrimHandler = (value) => {
        try {
            return value?.trim()
        } catch {
            return value
        }
    }

    useEffect(() => {
        if (headers.length > 0 && FullData.mappedResults) {
            setData([...FullData.mappedResults.map(row => headers.map(header => TrimHandler(row[header] || "")))]);
        }
    }, [headers, FullData]);

    const handleEdit = (rowIndex, colIndex, value) => {
        const updatedData = [...data];
        updatedData[rowIndex][colIndex] = value;
        setData(updatedData);
    };

    const HandleDelete = (index = '') => {
        const updatedData = data?.filter((_itm, _index) => _index != index);
        setData(updatedData)
    }

    const handleDownload = (e) => {
        e.preventDefault();
        if (!FullData || !FullData.mappedResults) return;
        loader(true)
        const updatedMappedResults = data.map(row => {
            let obj = {};
            headers.forEach((header, index) => {
                obj[header] = row[index] || "";
            });
            return obj;
        });
        let payload = {
            ...FullData,
            mappedResults: updatedMappedResults.map((_itm) => {
                let updatedItm = { ..._itm };
                if (!moment(_itm['Load Start Date'], 'MM/DD/YYYY', true).isValid()) {
                    updatedItm['Load Start Date'] = '';
                }
                if (!moment(_itm['Load End Date'], 'MM/DD/YYYY', true).isValid()) {
                    updatedItm['Load End Date'] = '';
                } else {
                    if (!_itm['Load End Time']) {
                        updatedItm['Load End Time'] = '23:59'
                    }
                }
                if (isNaN(_itm['Trip Count'])) {
                    updatedItm['Trip Count'] = 0;
                }
                return updatedItm;
            })
        };
        let url = ''
        if (id === environment?.rfpsId) {
            url = `import/loads/preview/data?board_id=${environment?.rfpsId}`;
        } else if (id === environment?.contractId) {
            url = `import/contract/loads/preview/data?board_id=${environment?.contractId}`;
        } else {
            url = `import/loads/preview/data?board_id=${id}`;
        }
        ApiClient.post(url, payload)
            .then(response => {
                if (response?.success) {
                    try {
                        document.getElementById('closeModalCSV').click();
                    } catch { }
                    Swal.fire({
                        text: response.message,
                        icon: "success",
                    });
                    getData()
                }
                loader(false)
            })
            .catch(error => {
                console.error("Error sending data:", error);
            });
    };

    return (
        <div className="p-4 space-y-4">
            <form onSubmit={handleDownload}>
                {data.length > 0 && (
                    <div className="overflow-auto border border-bottom-0 rounded-lg">
                        <table className="w-full border-collapse text-left">
                            <thead>
                                <tr className="bg-gray-200">
                                    <th className="p-2 border bg-primary text-white"># </th>
                                    {headers.map((header, index) => (
                                        <th key={index} className="p-2 border bg-primary text-white">{header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row, rowIndex) => (
                                    <tr key={rowIndex} className="odd:bg-gray-50 even:bg-white">
                                        <td className="p-2 border">
                                            <span
                                                style={{ cursor: 'pointer' }}
                                                className="edit_icon"
                                                onClick={() => { HandleDelete(rowIndex) }}
                                            >
                                                <i className="material-icons delete"> delete </i>
                                            </span>
                                        </td>
                                        {row.map((cell, colIndex) => {
                                            const loadStartIndex = headers.indexOf('Load Start Date');
                                            const loadStartDate = row[loadStartIndex]; // value in DD/MM/YYYY format
                                            const minDate = moment(loadStartDate, 'MM/DD/YYYY', true).isValid()
                                                ? moment(loadStartDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
                                                : '';

                                            return (
                                                <td key={colIndex} className="p-2 border">
                                                    {headers[colIndex] === 'Load Start Date' || headers[colIndex] === 'Load End Date' ? (
                                                        <DatePicker
                                                            selected={moment(cell, 'MM/DD/YYYY', true).isValid() ? moment(cell, 'MM/DD/YYYY').toDate() : null}
                                                            onChange={(date) => {
                                                                const formatted = date ? moment(date).format('MM/DD/YYYY') : '';
                                                                handleEdit(rowIndex, colIndex, formatted);
                                                            }}
                                                            minDate={
                                                                headers[colIndex] === 'Load End Date' && moment(minDate, 'YYYY-MM-DD', true).isValid()
                                                                    ? moment(minDate, 'YYYY-MM-DD').toDate()
                                                                    : null
                                                            }
                                                            required={headers[colIndex] === 'Load Start Date' && row[2]}
                                                            dateFormat="MM/dd/yyyy"
                                                            className="border-1 p-1 w-full"
                                                            placeholderText="MM/DD/YYYY"
                                                        />
                                                    ) : (
                                                        <input
                                                            type={headers[colIndex] === 'Trip Count' ? 'number' : 'text'}
                                                            pattern={
                                                                ['Load End Time', 'Load Start Time', 'Arrive Time', 'Leave Time'].includes(headers[colIndex])
                                                                    ? '([01][0-9]|2[0-3]):[0-5][0-9]'
                                                                    : undefined
                                                            }
                                                            required={headers[colIndex] === 'Load Start Date' && row[2]}
                                                            value={cell}
                                                            onChange={(e) => handleEdit(rowIndex, colIndex, e.target.value)}
                                                            className="border-1 p-1 w-full"
                                                        />
                                                    )}
                                                </td>

                                            )

                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                <div className="text-end mt-3">
                    {data.length > 0 && (
                        <button type="submit" className="btn btn-primary mb-0 py-2">Save</button>
                    )}
                </div>
            </form>
        </div>
    );
});

export default CSVEditor;
